import { Inject, Injectable } from "@angular/core";
import { Environment } from "../classes/environment";
import { User } from "../classes/user";
import { delay, map, Observable, of } from "rxjs";
import { ChatFile, ChatGroup, Message } from "../classes/chat";


@Injectable( { providedIn: 'root' } )
export class ChatPrototypeService {


	private prototypeUsers: User[] = [];
	private prototypeMessages: { [key: string]: Message[] } = {};
	private prototypeGroups: ChatGroup[] = [];
	private prototypeLastChatIds: string[] = [];


	constructor(
		@Inject( "environment" ) protected environment: Environment,
	) {}


	generateProtoData( myUser: User ) {

		console.warn( "CHAT PROTOTYPE DATA GENERATION...", myUser )

		this.prototypeUsers = [];
		this.prototypeMessages = {};
		this.prototypeGroups = [];
		this.prototypeLastChatIds = [];

		const myId = myUser.ebeId;

		const user0 = new User();
		user0.ebeId = myId;
		user0.ebeName = myUser.ebeName ;
		user0.ebeVorname = myUser.ebeVorname;
		this.prototypeUsers.push( user0 );


		const user1 = new User();
		user1.ebeId = "karlmueller";
		user1.ebeName = "Müller" ;
		user1.ebeVorname = "Karl";
		this.prototypeUsers.push( user1 );

		this.prototypeMessages[ "karlmueller" ] = [];

		let msg = new Message();
		const dt = new Date();
		dt.setTime( dt.getTime() - 4*24*3600*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "Hello, how are you? This should be a very long message so that we can test how it fit into the screen.";
		msg.textPerLine = msg.text.split( '\n' );
		msg.senderId = myId;
		this.prototypeMessages[ "karlmueller" ].push( msg );

		msg = new Message();
		dt.setTime( dt.getTime() + (Math.trunc(Math.random()*5)*60 + Math.trunc(Math.random()*60)) * 60*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "I'm fine. This should be a very long message so that we can test how it fit into the screen.";
		msg.textPerLine = msg.text.split( '\n' );
		msg.senderId = "karlmueller";
		this.prototypeMessages[ "karlmueller" ].push( msg );

		msg = new Message();
		dt.setTime( dt.getTime() + (Math.trunc(Math.random()*5)*60 + Math.trunc(Math.random()*60)) * 60*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "Could we have a meeting on Tuesday?";
		msg.textPerLine = msg.text.split( '\n' );
		msg.senderId = myId;
		this.prototypeMessages[ "karlmueller" ].push( msg );

		/*
		msg = new Message();
		dt.setTime( dt.getTime() + (Math.trunc(Math.random()*5)*60 + Math.trunc(Math.random()*60)) * 60*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "in the morning?";
		msg.senderId = myId;
		this.prototypeMessages[ "karlmueller" ].push( msg );
		*/

		msg = new Message();
		dt.setTime( dt.getTime() + (Math.trunc(Math.random()*5)*60 + Math.trunc(Math.random()*60)) * 60*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "I will be busy this day. What about Wednesday 09:30?";
		msg.textPerLine = msg.text.split( '\n' );
		msg.senderId = "karlmueller";
		const chatFiles: ChatFile[] = [];
		const chatFileNames = [
			"a.jpg", "hoho.png", "haha.jpg", "ha space ha.gif",
			"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa.pdf", 
			"ha_underscore____.gif", "123123213123.jpg", "5.tar", "666.666", "XOXOX.XOXO", "virus.exe"
		];
		for( let i=0; i < 10; i++ ) {
			const chatFile = new ChatFile();
			chatFile.id = "chatFile" + i;
			chatFile.fileName = chatFileNames[i];
			chatFiles.push( chatFile );
		}
		msg.files = chatFiles;
		this.prototypeMessages[ "karlmueller" ].push( msg );
		
		msg = new Message();
		dt.setTime( dt.getTime() + (Math.trunc(Math.random()*5)*60 + Math.trunc(Math.random()*60)) * 60*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "yeah great, see you then!";
		msg.textPerLine = msg.text.split( '\n' );
		msg.senderId = myId;
		this.prototypeMessages[ "karlmueller" ].push( msg );

		/*
		msg = new Message();
		dt.setTime( dt.getTime() + (Math.trunc(Math.random()*5)*60 + Math.trunc(Math.random()*60)) * 60*1000 );
		msg.timestamp = dt.getTime();
		msg.text = "See you on Wednesday!";
		msg.senderId = "karlmueller";
		this.prototypeMessages[ "karlmueller" ].push( msg );
		*/


		const user2 = new User();
		user2.ebeId = "verylonguser";
		user2.ebeName = "VeryveryveryveryveryveryveryverylongFamilyName" ;
		user2.ebeVorname = "VeryveryveryvveryveryveryeryveryverylongFirstName";
		this.prototypeUsers.push( user2 );
		this.generateProtoMessages( user2.ebeId, myId );


		const firstNames = [
			"Andreas", "Frank", "Jörg", "Jürgen", "Klaus", "Michael", "Peter", "Stefan", "Thomas", "Uwe",
			"Andrea", "Angelika", "Birgit", "Gabriele", "Heike", "Martina", "Petra", "Sabine", "Susanne", "Ute",
			"Alexander", "Christian", "Daniel", "Dennis", "Jan", "Martin", "Michael", "Sebastian", "Stefan", "Thomas",
			"Anja", "Christina", "Julia", "Katrin", "Melanie", "Nadine", "Nicole", "Sabrina", "Sandra", "Stefanie"
		];
		const lastNames = [
			"Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter",
			"Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz",
			"Krause", "Meier", "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer", "Huber", "Kaiser", "Fuchs", "Peters",
			"Lang", "Scholz", "Möller", "Weiß", "Jung", "Hahn", "Schubert", "Vogel", "Friedrich", "Keller", "Günther", "Frank", "Berger", "Winkler", "Roth", "Beck", "Lorenz", "Baumann",
			"Franke", "Albrecht", "Schuster", "Simon", "Ludwig", "Böhm", "Winter", "Kraus", "Martin", "Schumacher", "Krämer", "Vogt", "Stein", 
			"Jäger", "Otto", "Sommer", "Groß", "Seidel", "Heinrich", "Brandt", "Haas", "Schreiber", "Graf", "Schulte", "Dietrich", "Ziegler",
			"Kuhn", "Kühn", "Pohl", "Engel", "Horn", "Busch", "Bergmann", "Thomas", "Voigt", "Sauer", "Arnold", "Wolff", "Bender", "Pfeiffer",
		];

		for( let i=0; i < 50; i++ ) {
			const user = new User();
			user.ebeId = "user" + i;
			user.ebeName = lastNames[ Math.floor(Math.random()*lastNames.length) ];
			user.ebeVorname = firstNames[ Math.floor(Math.random()*firstNames.length) ];
			this.prototypeUsers.push( user );
			this.generateProtoMessages( user.ebeId, myId );
		}


		const arr = [
			{ title: "Nachhaltigkeit", users: [ myId, "karlmueller", "verylonguser" ] },
			{ title: "Essen", users: [ myId, "user1", "user2", "user3", "user4", "user5" ] },
			{ title: "Umwelt", users: [ myId, "user10", "user20", "user30" ] },
		];
		for( const o of arr ) {
			const group = new ChatGroup();
			group.id = "id_group_" + this.prototypeGroups.length;
			group.title = o.title;
			group.users = o.users;
			group.bSystem = true;
			this.prototypeGroups.push( group );
			this.generateProtoMessages( group.id, myId );
		}

		const group = new ChatGroup();
		group.id = "id_group_" + this.prototypeGroups.length;
		group.title = "Gruppe ohne Nachrichten und einem sehr sehr langen Titel";
		group.users = [ myId ];
		group.bSystem = true;
		this.prototypeGroups.push( group );
		this.prototypeMessages[ group.id ] = [];


		for( let i=0; i<10; i++ ) {
			const group = new ChatGroup();
			group.id = "id_group_" + this.prototypeGroups.length;
			group.title = lastNames[ Math.floor(Math.random()*firstNames.length) ] + "s Gruppe";
			group.users = [ myId, "user10", "user20", "user30" ];
			group.bSystem = false;
			this.prototypeGroups.push( group );
			this.generateProtoMessages( group.id, myId );
		}


		this.prototypeLastChatIds = [ "karlmueller", "verylonguser" ];
		for( let i=0; i<10; i++ ) {
			this.prototypeLastChatIds.push( "id_group_" + i );
		}
		for( let i=0; i<4; i++ ) {
			this.prototypeLastChatIds.push( "user" + i );
		}
		
	}

	private generateProtoMessages( chatId: string, myId: string ) {

		this.prototypeMessages[ chatId ] = [];

		const strings = [
			"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa\naaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
			"Hi",
			"short msg",
			"This should be a very very very very long message so that we can test how it fit into the screen.",
			"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
			"Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to ",
			"The quick, brown fox jumps over a lazy dog",
			"The languages only differ in their grammar, their pronunciation and their most common words. One could refuse to pay expensive translators. To achieve this, it would be necessary to have uniform grammar, pronunciation and more common words. If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages. The new common language will be more simple and regular than the existing European languages. It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is.The European languages are members of the same family. Their separate existence is a myth. For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ in their grammar, their pronunciation and their most common words. One could refuse to pay expensive translators. To",
			"Sei es als Suppe, Kuchen oder dekorativ geschnitzt zu Halloween – im Herbst erfreut sich der Kürbis großer Beliebtheit. Auf den ersten Blick mag er durch seine Vielseitigkeit in der Küche überzeugen, doch seine gesundheitlichen Vorteile gehen weit darüber hinaus. Schaut man genauer hin, entpuppt er sich als wahres Fitness-Food. Doch was macht Kürbis eigentlich so gesund für Läuferinnen und Läufer, Sportlerinnen und Sportler? Im Folgenden werfen wir einen genaueren Blick auf die Nährstoffe und positiven Eigenschaften, die Kürbis zu einem wertvollen Bestandteil einer ausgewogenen Ernährung machen.",
			"Es ist schwierig, eine Kürbissorte als „die gesündeste Sorte“ zu bezeichnen. Jede Sorte hat ihre eigenen gesundheitlichen Vorteile, Nährwerte und Nährstoffgehälter – und vor allem ihren eigenen Geschmack. Die Wahl der richtigen Kürbissorte ist demnach abhängig von Ihren eigenen Vorlieben. Werfen wir daher nun einen Blick auf die bekanntesten Vertreter:",
			"Ein Ultra-Marathon vor dem Marathon – so kann man bezeichnen, was in den 1990er-Jahren nötig war, um am Everest-Marathon teilzunehmen. Schon eine Flugreise nach Kathmandu, Hauptstadt von Nepal, dauert so einige Zeit. Doch das ist Nichts gegen das, was danach kommt, wenn man 1991 am Mt. Everest-Marathon teilnehmen wollte. So wie laufen.de-Autor Stefan Schlett, der damals als erster deutscher Teilnehmer bei der 3. Auflage des höchsten Marathons der Welt dabei war.",
			"Nov 4 (Reuters) - The New York City Marathon on Sunday broke the record for the world's largest marathon, with 55,646 runners crossing the finish line in Central Park, organisers said. That beat the record set by Berlin's Marathon in September, when 54,280 completed the fellow World Marathon Major.",
			"In Südholstein werden seit drei Tagen 17 Tonnen Lachs vermisst. Der Eigentümer und auch die Polizei in Norderstedt (Kreis Segeberg) sind ratlos. Eigentlich sollte der Lachs von Dänemark noch Polen geliefert werden. Die Spedition hatte den Sattelschlepper per GPS geortet, nachdem der Laster nicht wie erwartet nach Polen zurückgekommen war. Die Ware hat laut Polizei einen Wert von rund 100.000 Euro. ",
			"Erreichen Sie neue Höhen mit InsurePORT - der starken Lösung, die Sie im Wettbewerb voranbringt.\n\nAls Anbieter hochmoderner Software-Technologie verschaffen wir Ihnen einen entscheidenden Vorsprung im Markt. Durch die Nutzung unserer Lösungen können Sie nicht nur Ihr Wachstum fördern, sondern auch die Effizienz und Qualität Ihres Unternehmens verbessern. \n\nVertrauen Sie auf unser Know-how und lassen Sie uns gemeinsam mit InsurePORT Ihr Unternehmen erfolgreich in die Zukunft führen."
		];
		const nbMsg = 1 + Math.ceil( Math.random()*25 );

		const tmss: number[] = [];
		const dt = new Date();
		dt.setTime( dt.getTime() - Math.round(Math.random()*5*24*60) * 60*1000 );

		for( let i=0; i < nbMsg; i++ ) {
			dt.setTime( dt.getTime() - Math.round(Math.random()*6*60) * 60*1000 );
			tmss.push( dt.getTime() );
		}
		tmss.sort();

		const group = this.prototypeGroups.find( g => g.id == chatId );
		const potentialSenders = group ? group.users : [ chatId, myId ];


		for( let i=0; i < nbMsg; i++ ) {

			dt.setTime( tmss[i] );

			const msg = new Message();
			msg.timestamp = tmss[i];
			msg.text = strings[ Math.floor( Math.random()*strings.length ) ];
			msg.textPerLine = msg.text.split( '\n' );
			msg.senderId = potentialSenders[ Math.floor( Math.random()*potentialSenders.length ) ];

			this.prototypeMessages[ chatId ].push( msg );

		}

	}


	getContacts(): Observable<User[]> {

		return of( this.prototypeUsers );

	}

	getLastMessages( chatId: string ): Observable<Message[]> {

		return of( this.prototypeMessages[ chatId ] ).pipe(
			delay( 400 )
		);

	}

	sendMessage( chatId: string, txt: string, files: ChatFile[], senderId: string ): Observable<Message|null> {
		
		const msg = new Message();
		msg.id = "" + Math.round(Math.random()*100000);
		msg.senderId = senderId;
		msg.text = txt;
		msg.timestamp = (new Date()).getTime();
		msg.files = files;

		const messages = this.prototypeMessages[ chatId ];
		if( !messages ) {
			console.warn( "not found", chatId, this.prototypeMessages );
			return of(null);
		}
		msg.textPerLine = txt.split( '\n' );
		messages.push( msg );

		return of(msg).pipe( delay(1000) );

	}

	getLastChatIds(): Observable<string[]> {

		return of( this.prototypeLastChatIds );

	}

	getChatGroups(): Observable<ChatGroup[]|null> {

		return of( this.prototypeGroups );

	}

	getSystemChatGroupsOfUser( userId: string ): Observable<ChatGroup[]|null> {

		return this.getChatGroups().pipe(
			map( groups => {
				if( !groups ) return null;
				return groups
					.filter( g => g.bSystem )
					.filter( g => g.users.includes(userId) );
	 		} )
		);

	}

	deleteChatGroup( groupId: string ): Observable<boolean> {

		const i = this.prototypeGroups.findIndex( g => g.id == groupId );
		if( i == -1 ) return of(false);

		this.prototypeGroups.splice( i, 1 );
		return of(true);

	}


	saveChatGroup( chatGroup: ChatGroup ): Observable<ChatGroup|null> {

		return chatGroup.id ? this.editChatGroup( chatGroup ) : this.createChatGroup( chatGroup );

	}

	editChatGroup( chatGroup: ChatGroup ): Observable<ChatGroup|null> {

		const existingGroup = this.prototypeGroups.find( g => g.id == chatGroup.id );
		if( !existingGroup ) return of( null );

		existingGroup.title = chatGroup.title;
		existingGroup.users = chatGroup.users;

		return of( existingGroup ).pipe( delay(400) );

	}

	createChatGroup( chatGroup: ChatGroup ): Observable<ChatGroup|null> {

		const newGroup = new ChatGroup();
		newGroup.id = "id_group_" + (this.prototypeGroups.length+1);
		newGroup.title = chatGroup.title;
		newGroup.users = chatGroup.users;
		this.prototypeGroups.push( newGroup );
		this.prototypeMessages[ newGroup.id ] = [];

		this.prototypeLastChatIds.splice( 0, 0, newGroup.id );

		return of( newGroup ).pipe( delay(400) );

	}


	addChatIdIntoLastChats( chatId: string ): boolean {

		if( this.prototypeLastChatIds.includes( chatId ) ) return true;

		const user = this.prototypeUsers.find( u => u.ebeId == chatId );
		if( user ) {
			this.prototypeLastChatIds.splice( 0, 0, chatId );
			return true;
		}

		const group = this.prototypeGroups.find( g => g.id == chatId );
		if( group ) {
			this.prototypeLastChatIds.splice( 0, 0, chatId );
			return true;
		}

		console.warn( "chatId NOTFOUND", chatId, this.prototypeUsers )
		return false;

	}

	addUserToChatGroup( userId: string, chatGroupId: string ): Observable<boolean> {

		const user = this.prototypeUsers.find( u => u.ebeId == userId );
		if( !user ) return of(false);

		const group = this.prototypeGroups.find( g => g.id == chatGroupId );
		if( !group ) return of(false);

		const n = group.users.findIndex( id => id == userId );
		if( n != -1 ) return of(true);

		group.users.push( userId );
		return of(true);

	}

	removeUserFromChatGroup( userId: string, chatGroupId: string ): Observable<boolean> {

		const user = this.prototypeUsers.find( u => u.ebeId == userId );
		if( !user ) return of(false);

		const group = this.prototypeGroups.find( g => g.id == chatGroupId );
		if( !group ) return of(false);

		const n = group.users.findIndex( id => id == userId );
		if( n == -1 ) return of(true);

		group.users.splice( n, 1 );
		return of(true);
		
	}


}

